var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.wrap)?_c('div',{staticClass:"text-center loading"},[_c('i',{class:`fa fa-circle-o-notch fa-spin ${_vm.iconClass}`})]):_c('i',{class:`fa fa-circle-o-notch fa-spin ${_vm.iconClass}`})
}
var staticRenderFns = []

export { render, staticRenderFns }